import { mediaUrl } from './Media';

/**
 * A page icon is an emoji, or `file:<id>` for an uploaded image. Anything else
 * is shown as text, so a stored value can never become a remote image.
 */
export function PageIcon({ icon }: { icon: string | null | undefined }): React.ReactElement | null {
  if (!icon) return null;
  if (icon.startsWith('file:')) {
    const fileId = icon.slice('file:'.length);
    if (!fileId) return null;
    return <img className="page-icon-img" src={mediaUrl(fileId)} alt="" loading="lazy" />;
  }
  return <>{icon}</>;
}
